import { render, staticRenderFns } from "./materialManage.vue?vue&type=template&id=aa10119e&scoped=true&"
import script from "./materialManage.vue?vue&type=script&lang=js&"
export * from "./materialManage.vue?vue&type=script&lang=js&"
import style0 from "./materialManage.vue?vue&type=style&index=0&id=aa10119e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa10119e",
  null
  
)

export default component.exports